module.exports = "/images/gh.svg?2559a8a8c5cc3c672488f82e8ecbd8f5";